import { render, staticRenderFns } from "./workgroupTax.vue?vue&type=template&id=9ce3adca"
import script from "./workgroupTax.vue?vue&type=script&lang=js"
export * from "./workgroupTax.vue?vue&type=script&lang=js"
import style1 from "./workgroupTax.vue?vue&type=style&index=1&id=9ce3adca&prod&lang=css"
import style2 from "./workgroupTax.vue?vue&type=style&index=2&id=9ce3adca&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports